export const PREFIX = {
  identity: "Identity",
  tracking: "BarCodeQRCode",
  masterData: "MasterDataConfiguration",
  receive: "Receive",
  report: "Report",
  export: "Export",
  role: "Role",
  permission: "Permission",
  materialRequirement: "RequestMaterial",
  inProcessCheck: "in-process-check",
  inProcessCheckDetail: "in-process-check-detail",
  qualityCondition: "quality-checking-conditions",
  File: "File",
};

export const GROUP_CODE = {
  zoneTemperature: "ZoneTemperature",
};

export const FIRST_PAGE = 1;
export const CURRENT_PAGE_SIZE = 100;

/**
 * @Type : download excel name
 */
export const EXPORT_FILE_NAME = {
  productMasterData: "Product_Master_Data",
  warehouseMasterData: "Warehouse_Master_Data",
  zoneMasterData: "Zone_Master_Data",
  locationMasterData: "Location_Master_Data",
  palletMasterData: "Pallet_Master_Data",
  companyMasterData: "Company_Master_Data",
  userMasterData: "User_Master_Data",
  receive: "Receiving",
  receiveDetail: "Receive_Detail",
  loadingOrder: "Loading_Order",
  loadingOrderDeliveryProgress: "Loading_Order_Delivery_Progress",
  productionPlan: "Production_Plan",
  productionPlanDetail: "Production_Plan_Detail",
  auditTrail: "Audit_Trail",
  qrCodeTracking: "QR_Code_Tracking",
  qrCodeBank: "QR_Code_Bank",
  warehouseReport: "Warehouse_Report",
  packingReport: "Packing_Report",
  forkliftPerformanceReport: "Forklift_Performance_Report",
  deliveryReport: "Delivery_History_Report",
  deliveryForMarketingReport: "Delivery_History_For_Marketing_Report",
  inventoryComparisonReport: "SAP_Report",
  inventoryComparisonForm: "Inventory_Comparison_Form",
  cycleCountReport: "Cycle_Count_Report",
  returnReport: "Return_Report",
  productionPlanForm: "Production_Plan_Form",
  loadingOrderForm: "Loading_Order_Form",
  receiveForm: "Receive_Form",
  materialRequisition: "Material_Requisition_Form",
  materialRequisitionDetail: "Material_Requisition_Form",
  materialRequisitionForm: "Material_Requisition_Form",
  materialMovementForm: "Material_Movement_Form",
  packagingMovementForm: "Packaging_Movement_Form",
  cycleCountProductForm: "Cycle_Count_Product_Form",
  cycleCountLocationForm: "Cycle_Count_Location_Form",
  listConfirmCycleCountLocation: "Location_List_Confirm",
  listCycleCountLocation: "Location_List",
  cycleCountQACollect: "Cycle_Count_QA_Collect",
  enUserGuide: "ELANCO_UserGuide_EN",
  vnUserGuide: "SCHENKER_UserGuide_VN",
  requestMaterialDetail: "Request_Material_Detail",
  stockMovement: "Stock_Movement",
};
//msd production
// export const CONFIG = {
//   ISSUER: "https://auth.pingone.com/89f2ffa0-b606-4ba2-9649-290e20944e5f/as",
//   CLIENT_ID: "a3cf8817-32fc-4fa9-a6cd-eac541e0b54a",
//   SCOPES: "openid",
//   AUTHORIZATION_ENDPOINT: "https://auth.pingone.com/89f2ffa0-b606-4ba2-9649-290e20944e5f/as/authorize",
//   SIGN_OFF_ENDPOINT: "https://auth.pingone.com/89f2ffa0-b606-4ba2-9649-290e20944e5f/as/signoff",
//   REDIRECT_URI: "https://uatmsdvnqrcode.msd.com",
// };

//test
// export const CONFIG = {
//   ISSUER: "https://auth.pingone.com/dba95730-103d-48b0-a279-df50a95e497b/as",
//   CLIENT_ID: "fad2e377-66d0-434c-b09d-d931678803c0",
//   SCOPES: "openid profile",
//   AUTHORIZATION_ENDPOINT: "https://auth.pingone.com/dba95730-103d-48b0-a279-df50a95e497b/as/authorize",
//   SIGN_OFF_ENDPOINT: "https://auth.pingone.com/dba95730-103d-48b0-a279-df50a95e497b/as/signoff",
//   REDIRECT_URI: "http://localhost:3000/login",
// };

export const EMAIL_PATTERN = "@scssolutions.io";
